import React from 'react';

import { Control, Controller } from 'react-hook-form';

import { DateControllerInputs } from 'components/shared/DateController/DateControllerInputs';

interface IDateControllerProps {
    className?: string;
    name: string;
    control: Control;
    size?: 'sm' | 'lg';
    disabled?: boolean;
}

export const DateController = ({className, name, control, size, disabled}: IDateControllerProps) => {
    return (
        <Controller
            name={name}
            control={control}
            render={(
                {onChange, onBlur, value, ref},
                {invalid}
            ) => (
                <DateControllerInputs
                    className={className}
                    name={name}
                    value={value}
                    onBlur={onBlur}
                    onChange={onChange}
                    invalid={invalid}
                    inputRef={ref}
                    size={size}
                    disabled={disabled}
                    lastYearFromNow={-15}
                />
            )}
        />
    );
};
